import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

// ui-kit
import { Row, Col, ContainerFluid } from '@navent-jobs/ui-kit/components/grid'
import { Modal } from '@navent-jobs/ui-kit/components/modal'

// mixins
import {
  ModalFooterComponent,
  ButtonContainer,
  CustomButton,
  ModalContent,
  Title,
  AlertImage,
  Description,
} from './mixins'

// constants
import { SiteIds, SITE_ID } from '../../../../constants'

import alertImgSrcZj from '../../../../assets/images/commons/alert-zj.svg'
import alertImgSrcBm from '../../../../assets/images/commons/alert-bm.svg'

const alertImage = SITE_ID === SiteIds.ZJAR ? alertImgSrcZj : alertImgSrcBm

export interface ModalActualizacionCvProps {
  visible: boolean
  closeModal: () => void
}

const ModalTitle = () => {
  const { t } = useTranslation()

  return (
    <>
      <AlertImage src={alertImage} />
      <Title>{t('modalActualizacionCv.title', { cv: t('cv') })}</Title>
    </>
  )
}

const ModalFooter = () => {
  const { t } = useTranslation()
  const history = useHistory()

  return (
    <ModalFooterComponent>
      <ContainerFluid>
        <Row>
          <Col>
            <ButtonContainer>
              <CustomButton
                buttonoptions={{ variant: 'primary' }}
                onClick={() => {
                  history.push('/postulantes/curriculum')
                }}
              >
                {t('modalActualizacionCv.cta', { cv: t('cv') })}
              </CustomButton>
            </ButtonContainer>
          </Col>
        </Row>
      </ContainerFluid>
    </ModalFooterComponent>
  )
}

const ModalActualizacionCv = ({ visible, closeModal }: ModalActualizacionCvProps) => {
  const { t } = useTranslation()

  return (
    <Modal
      skin="with-info"
      title={<ModalTitle />}
      width={500}
      visible={visible}
      onClose={closeModal}
      footer={<ModalFooter />}
    >
      <ModalContent>
        <Description>{t('modalActualizacionCv.description', { cv: t('cv') })}</Description>
      </ModalContent>
    </Modal>
  )
}

export default ModalActualizacionCv
